import React from "react";
import Footer from "../../components/Footer";
import whatsNextVideo from "../../videos/cpn_what's_next (720p).mp4";

const WhatsNext = () => {
  return (
    <>
      <div className="container mb-5" style={{ minHeight: "60vh" }}>
        <h2 className="text-center mb-4">CPN What's Next</h2>
        <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
          <video
            src={whatsNextVideo}
            controls
            playsInline
            preload="metadata"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "#000",
            }}
            title="CPN What's Next"
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default WhatsNext;
